import React from 'react';

export default function Base(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={218.617}
            height={195.738}
            style={{
                shapeRendering: "geometricPrecision",
                textRendering: "geometricPrecision",
                imageRendering: "optimizeQuality",
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
            viewBox="0 0 892 799"
            className={props.className}
        >
            <defs>
                <style>
                    {`
                        #c-${props.id} .fil0 {fill:#${props.base}}
                        #c-${props.id} .fil1 {fill:#252422;fill-rule:nonzero}
                        #c-${props.id} .fil2 {fill:#${props.sleeve};fill-rule:nonzero}
                    `}
                </style>
            </defs>
            <g id={`c-${props.id}`}>
                <path className="fil0" d="M521 39c-19,10 -48,19 -89,18 -37,-1 -65,-10 -83,-19 15,35 46,56 86,56 38,0 71,-22 86,-55z"/>
                <path className="fil2" d="M49 219l-16 17 107 109 16 -17 49 -51c5,-83 -26,-156 -37,-179 -16,15 -28,28 -28,28l-92 93z"/>
                <path className="fil2" d="M736 331l14 14 109 -109 -15 -15 -107 -109c-4,-4 -11,-10 -18,-17 -9,21 -41,99 -31,186l49 49z"/>
                <polygon className="fil0" points="748,378 701,331 701,331 "/>
                <polygon className="fil0" points="532,2 534,0 532,2 "/>
                <path className="fil0" d="M348 10c0,0 1,1 2,1 -1,0 -1,-1 -2,-1z"/>
                <path className="fil0" d="M565 29c-2,0 -12,-2 -14,-2 -13,53 -59,91 -116,91 -57,0 -101,-36 -114,-90 -2,0 -12,3 -14,3 -14,3 -24,6 -33,9l-6 2c-17,5 -54,21 -68,31 -8,6 -16,13 -24,19 11,23 50,111 36,209l0 0 0 460c33,4 129,14 226,14 127,0 215,-10 242,-14l0 -481c-9,-92 25,-173 33,-191 -8,-7 -15,-14 -19,-16 -12,-9 -39,-22 -53,-27 -12,-4 -42,-12 -76,-17z"/>
                <path className="fil1" d="M565 29c-2,0 -12,-2 -14,-2 -13,53 -59,91 -116,91 -57,0 -101,-36 -114,-90 -2,0 -12,3 -14,3 -14,3 -24,6 -33,9l-6 2c-17,5 -54,21 -68,31 -8,6 -16,13 -24,19 11,23 50,111 36,209l0 0 0 460c33,4 129,14 226,14 127,0 215,-10 242,-14l0 -481c-9,-92 25,-173 33,-191 -8,-7 -15,-14 -19,-16 -12,-9 -39,-22 -53,-27 -12,-4 -42,-12 -76,-17zm171 302l14 14 109 -109 -15 -15 -107 -109c-4,-4 -11,-10 -18,-17 -9,21 -41,99 -31,186l49 49zm-686 -112l-16 17 107 109 16 -17 49 -51c5,-83 -26,-156 -37,-179 -16,15 -28,28 -28,28l-92 93zm472 -179c-19,10 -48,19 -89,18 -37,-1 -65,-10 -83,-19 15,35 46,56 86,56 38,0 71,-22 86,-55zm-204 -35l0 -1 5 0c3,0 5,-1 8,-1l6 -1 1 1 4 0c0,1 0,2 0,4 6,5 37,26 92,27 67,2 96,-27 97,-28l0 0c0,-1 0,-1 0,-2l2 0 2 -2 6 1c45,6 92,17 108,23 16,6 44,20 59,30 10,7 43,37 46,41l139 141 -144 143 -48 -47 0 450 -10 2c-4,1 -94,16 -253,16 -119,0 -234,-16 -235,-16l-9 -1 0 -453 -51 49 -144 -143 124 -126c1,-1 31,-34 61,-56 19,-13 59,-30 75,-35l6 -2c13,-4 28,-9 51,-13z"/>
            </g>
        </svg>
    );
}
